










import { Component, Vue } from "vue-property-decorator";
import OtherCompanyConstructionEdit from "../components/OtherCompanyConstructionEdit.vue";
// import SelectOption from "@/common/ui/presenters/select-option";
import {
  getOtherCompanyConstruction,
  saveOtherCompanyConstruction
} from "../../api/other-company-construction-api";
// import { templateApi } from "@/api";
import createOtherCompanyConstructionOutput from "../../models/factories/createOtherCompanyConstructionOutput";
import OtherCompanyConstructionFormData from "../../models/factories/OtherCompanyConstructionFormData";
import { Construction, getConstruction } from "../../api/construction-api";

@Component({
  components: {
    OtherCompanyConstructionEdit
  }
})
export default class OtherCompanyConstructionNewPage extends Vue {
  otherCompanyConstruction = createOtherCompanyConstructionOutput();
  private construction: Construction[] = [];

  templates = "";
  taskTypes = "";

  private async initOtherCompanyConstruction() {
    this.otherCompanyConstruction = await getOtherCompanyConstruction();
  }

  private async loadConstructionList() {
    this.construction = await getConstruction();
  }

  get constructionOptions() {
    return [
      ...this.construction.map(s => ({
        text: s.name,
        value: String(s.id)
      }))
    ];
  }

  private created() {
    this.loadConstructionList();
  }

  async ok() {
    await this.save();
    this.goListPage();
  }

  private async save() {
    if (!this.otherCompanyConstruction) return;
    const d = OtherCompanyConstructionFormData(this.otherCompanyConstruction);
    await saveOtherCompanyConstruction(d);
  }

  private goListPage() {
    this.$router.push({ name: "other-company-construction-list" });
  }

  cancel() {
    this.goListPage();
  }
}
